import { useState } from 'react';
import { faqItems } from '@/mocks/homeData';

export default function FaqSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100/70">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-2">关于爆料网，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item) => {
            const isOpen = openId === item.id;
            return (
              <div
                key={item.id}
                className="bg-background-50 rounded-xl border border-background-200/60 overflow-hidden"
              >
                <button
                  onClick={() => toggle(item.id)}
                  className="w-full flex items-center justify-between p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors"
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                    {item.question}
                  </h3>
                  <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 transition-colors ${
                    isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-200 text-foreground-500'
                  }`}>
                    <i className={`text-sm transition-transform duration-300 ${isOpen ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                  </div>
                </button>
                <div
                  className={`transition-all duration-300 overflow-hidden ${
                    isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="px-5 pb-5">
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}